import React from "react";
import PropTypes from "prop-types";
import "./CreditCardPaymentType.scss";
import { FormattedDate, FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import CreditCardMarketingBannerContainer from "app/pages/Booking/Payment/CreditCardMarketingBanner/CreditCardMarketingBannerContainer";
import CreditCardFieldsetContainer from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldsetContainer";

class CreditCardPaymentType extends React.PureComponent {
	render() {
		const {
			payNowAmount,
			payLaterAmount,
			dueDate,
			field = { number: {} },
			onCreditCardInputsBlur,
			onCreditCardInformationChange,
			showAmountToPay,
		} = this.props;

		return (
			<div className="creditcard-payment-type">
				<div className="creditcard-payment-type__marketing">
					<CreditCardMarketingBannerContainer />
				</div>
				<div className="creditcard-payment-type__pay-amount">
					{payLaterAmount > 0 ? (
						<FormattedMessage id="payment.pay.now.amount" />
					) : (
						<FormattedMessage id="payment.pay.all" />
					)}
					<span>
						<AmountContainer amount={payNowAmount} />
					</span>
				</div>
				{payLaterAmount > 0 && (
					<div className="creditcard-payment-type__pay-amount creditcard-payment-type__pay-amount--subtitle">
						<FormattedMessage
							id="payment.pay.later.amount"
							values={{
								dueDate: (
									<FormattedDate
										timeZone="UTC"
										day="2-digit"
										month="2-digit"
										year="numeric"
										value={dueDate}
									/>
								),
							}}
						/>
						<span>
							<AmountContainer amount={payLaterAmount} />
						</span>
					</div>
				)}
				<CreditCardFieldsetContainer
					fields={field}
					onBlur={onCreditCardInputsBlur}
					onCreditCardInformationChange={onCreditCardInformationChange}
					showAmountToPay={showAmountToPay}
				/>
			</div>
		);
	}
}

CreditCardPaymentType.propTypes = {
	payNowAmount: PropTypes.number,
	payLaterAmount: PropTypes.number,
	dueDate: PropTypes.number,
	field: PropTypes.object,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
	showAmountToPay: PropTypes.bool,
};

export default CreditCardPaymentType;
